import React from 'react';
import { Device } from '@interfaces';

export const DeviceContext = React.createContext<Device>('mobile');

/**
 * Use DeviceConsumer to access
 *
 * @usage
 * ```jsx tsx
 * <DeviceConsumer>
 *   {device => (
 *     <div>The device is: {device}</div>
 *   )}
 * </DeviceConsumer>
 * ```
 */
export const DeviceConsumer = DeviceContext.Consumer;

interface IDeviceProvider {
    children: React.ReactNode;
    device?: Device;
}

/**
 * In order to render `device specific component` from **tests**, use this provider as
 * a wrapper and pass the device type (`mobile`, `tablet` or `desktop`)
 *
 * @param device
 * @default mobile
 * @usage
 * ```jsx tsx
 * <DeviceProvider device="desktop">
 *   <DesktopComponent>Display some component here that requires device</DesktopComponent>
 * </DeviceProvider>
 * ```
 *
 * @note components inside should be using `DeviceConsumer`
 */
export const DeviceProvider: React.FC<IDeviceProvider> = ({ children, device = 'mobile' }) => {
    return <DeviceContext.Provider value={device}>{children}</DeviceContext.Provider>;
};
